import { render } from "./createTicketPopup.vue?vue&type=template&id=62043fb0&ts=true"
import script from "./createTicketPopup.vue?vue&type=script&lang=ts"
export * from "./createTicketPopup.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__